import { useCallback } from "react"
import { useAppContext } from "components/AppContext"

/**
 * Hook to determine if an environmental objective should be disabled
 * based on collected data availability.
 *
 * Rules:
 * - SDG 7: Disabled if no energy consumption data
 * - SDG 12: Disabled if no equipment inventories collected
 * - SDG 15: Disabled if no equipment inventories OR no printing module active OR no AI services
 *
 * @returns {Function} Function that takes an objectiveId and returns boolean
 */
const useObjectiveDisabled = () => {
  const { envScore } = useAppContext()

  return useCallback(
    (objectiveId) => {
      if (!envScore) return false

      switch (objectiveId) {
        case 7:
          // SDG 7 requires at least one of: nergy consumption data
          return !envScore.odd7_energy_consumption

        case 12:
          // SDG 12 requires equipment inventories to be collected
          return !envScore.has_equipment_inventories

        case 15:
          // SDG 15 requires at least one of: equipment inventories, printing module, or AI services
          return (
            !envScore.has_equipment_inventories &&
            !envScore.has_printing &&
            !envScore.has_ai_services
          )

        default:
          return false
      }
    },
    [envScore]
  )
}

export default useObjectiveDisabled
